module.exports = "/_next/static/media/bdf3a1e56f3fe533ee2f7339858bdbef.svg";